import v, { useState as L, useEffect as $ } from "react";
import e from "prop-types";
import q from "lodash.noop";
import B from "classnames";
import t from "./index1388.mjs";
import { EMAIL_STATES as c, EMAIL_BASE_CLASS as a } from "./index257.mjs";
const F = ({ classes: s, state: l, disabled: o, required: n }) => B(
  t[a],
  t[`${a}--${l}`],
  o && t[`${a}--disabled`],
  n && t[`${a}--required`],
  s
), p = (s) => {
  const {
    autocomplete: l,
    disabled: o,
    id: n,
    name: d,
    onChange: f,
    onFocus: g,
    onBlur: E,
    placeholder: b,
    readonly: h,
    required: i,
    state: C,
    classes: y,
    title: A,
    value: r
  } = s, S = F({
    classes: y,
    state: C,
    disabled: o,
    required: i
  }), [T, m] = L(r), _ = ({ target: { value: u } }) => {
    m(u), f(u);
  };
  return $(() => {
    m(r);
  }, [r]), /* @__PURE__ */ v.createElement(
    "input",
    {
      autoComplete: l ? "on" : "off",
      className: S,
      disabled: o,
      id: n,
      name: d,
      onChange: _,
      onFocus: g,
      onBlur: E,
      placeholder: b,
      readOnly: h,
      required: i,
      title: A,
      type: "email",
      value: T
    }
  );
};
p.propTypes = {
  autocomplete: e.bool,
  classes: e.string,
  disabled: e.bool,
  id: e.string,
  name: e.string,
  onChange: e.func,
  onFocus: e.func,
  onBlur: e.func,
  placeholder: e.string,
  readonly: e.bool,
  required: e.bool,
  state: e.oneOf(Object.values(c)),
  title: e.string,
  value: e.string
};
p.defaultProps = {
  state: c.DEFAULT,
  onChange: q
};
export {
  c as EMAIL_STATES,
  p as Email,
  p as default
};
